import { useEffect } from 'react';
import {
  Colors,
  createCreateUseModal,
  Flex,
  IconHeartFilled,
} from '@banhala/ui-kit';
import { isWeb } from 'shared/src/utils';
import { getScreenWidth } from 'shared/src/utils/getScreenWidth/getScreenWidth';
import { Keyboard } from 'react-native';
import Animated, {
  useSharedValue,
  useAnimatedStyle,
  withSpring,
  withTiming,
  withSequence,
} from 'react-native-reanimated';
import { scheduleOnRN } from 'react-native-worklets';

const createLikeActionAnimationModal = createCreateUseModal({
  modalProps: {
    coverScreen: true,
    style: {
      margin: 0,
      padding: 0,
      justifyContent: 'center',
    },
    deviceWidth: isWeb ? getScreenWidth() : undefined,
    animationIn: 'fadeIn',
    animationOut: 'fadeOut',

    animationInTiming: 1,
    animationOutTiming: 1,
    backdropColor: 'transparent',
    // backdropTransitionInTiming: 10,
    // backdropTransitionOutTiming: 10,
    onBackButtonPress() {
      Keyboard?.dismiss();
    },
    onBackdropPress() {
      Keyboard?.dismiss();
    },
  },
  cancelOnBackButtonPress: true,
  cancelOnBackdropPress: true,
});

const LikeAnimationContent: React.FC<{ onFinish: () => void }> = ({
  onFinish,
}) => {
  const scale = useSharedValue(0.2);
  const opacity = useSharedValue(0);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: opacity.value,
    transform: [{ scale: scale.value }],
  }));

  useEffect(() => {
    opacity.value = withTiming(1, { duration: 500 });
    scale.value = withSequence(
      withSpring(1, { damping: 12, stiffness: 500, mass: 0.5 }),
      withTiming(0.8, { duration: 500 }, finished => {
        if (finished) {
          scheduleOnRN(onFinish);
        }
      }),
    );
  }, [scale, opacity, onFinish]);

  return (
    <Flex.Center width={'100%'} height={'100%'}>
      <Animated.View style={animatedStyle}>
        <IconHeartFilled size={140} fill={Colors.content_pink_primary} />
      </Animated.View>
    </Flex.Center>
  );
};

export const useLikeActionAnimation = createLikeActionAnimationModal(
  ({ confirm }) => {
    return <LikeAnimationContent onFinish={confirm} />;
  },
  {},
);
